import { AsyncPipe, NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';
import { GridModule, PagerModule, SharedFilterModule } from '@progress/kendo-angular-grid';
import { SkeletonModule } from '@progress/kendo-angular-indicators';
import { CollectionListWidgetComponent } from 'src/app/features/bizzmine/widgets/collection-list-widget/collection-list-widget.component';
import { GridComponent } from 'src/app/shared/components/grid/grid.component';
import { FilterComponent } from 'src/app/shared/components/ui/filter-component/filter.component';
import { IconComponent } from 'src/app/shared/components/ui/icon/icon.component';
import { TranslatePipe } from 'src/app/shared/pipes/translate/translate.pipe';
import { formsActions } from 'src/app/store/features/forms/forms-actions';
import { GridGroupSortDto } from 'src/models/ts/grid-group-sort-dto.model';
import { GridParentFilter } from 'src/models/ts/grid-parent-filter.model';
import { StateType } from 'src/models/ts/state-type.model';
import { ExtensionIconComponent } from '../../../../../shared/components/ui/icon/extension-icon/extension-icon.component';
import { KENDO_POPUP } from '@progress/kendo-angular-popup';
import { DecimalPipe } from 'src/app/shared/pipes/decimal/decimal.pipe';
import { ProgressBarComponent } from '@progress/kendo-angular-progressbar';
import { SearchComponent } from 'src/app/shared/components/ui/search/search.component';

/**
 * Basically a clone of the collection list widget with
 * a few specific tweaks for the form.
 */
@Component({
  selector: 'bizz-form-collection-list',
  templateUrl: '../../../widgets/collection-list-widget/collection-list-widget.component.html',
  styleUrls: ['../../../widgets/collection-list-widget/collection-list-widget.component.scss'],
  imports: [
    IconComponent,
    GridModule,
    NgClass,
    SkeletonModule,
    TranslatePipe,
    PagerModule,
    FilterComponent,
    GridComponent,
    AsyncPipe,
    SharedFilterModule,
    ExtensionIconComponent,
    KENDO_POPUP,
    DecimalPipe,
    ProgressBarComponent,
    SearchComponent,
  ],
  standalone: true
})
export class FormCollectionListComponent extends CollectionListWidgetComponent {/**
   * Parent filter (for use with reverse linked collections)
   */
  @Input() public parentFilter: GridParentFilter | undefined;
  @Input() public formFieldId: number | undefined;

  public override ngOnInit(): void {
    super.ngOnInit();
    this.data.CanAccessTrashCan = this.data.CanAccessTrashCan && !this.parentFilter;
  }

  public override fetchSearchData(): void {
    //TODO: RV refactor this to use the new filter component
    if (this.userReversedFixedGroupsFilter) {
      if (!this.filterData) {
        this.filterData = {
          UseDefaultFilter: true,
          HasValues: true,
          Groups: [],

          UserReversedFixedGroups: this.userReversedFixedGroupsFilter,
          OperatorList: {
            StringOperators: [],
            StringOperatorsWithEntities: [],
            ComboOperators: [],
            NumberOperators: [],
            CheckOperators: [],
            OrgChartOperators: [],
            TypeaheadOperators: [],
            DocumentOperators: [],
            CanvasOperators: []
          },
          FilterList: [],
          currentFilterID: 0,
          FilterGroupType: [],
          IgnoreFilter: false
        };
      } else {
        this.filterData.UserReversedFixedGroups = this.userReversedFixedGroupsFilter;
        //TODO: should be correct, might need to check? OnInit should be false but when receiving filterdata, then set to false.
        this.filterData.UseDefaultFilter = false;
      }
    }
    this.listSearchFilter$.next({
      SearchFilters: !this.reportControl ? this.filterData : undefined,
      ListID: this.data.ListOptions.ListID,
      CanViewHiddenDocuments: this.canViewHiddenDocuments,
      CanViewDraftDocuments: this.canViewDraftDocuments,
      State: this.isTrashView ? StateType.Inactive : StateType.Active,
      Page: this.currentPage,
      Records: this.gridOptions.pageSize,
      Group: this.gridOptions.dataSource.group as GridGroupSortDto[],
      Sort: this.gridOptions.dataSource.sort as GridGroupSortDto[],
      ParentFilter: this.parentFilter,
      Search: this.searchTerm,
    });
  }

  public override newRecord(): void {
    if (this.parentFilter != undefined) {
      this.store$.dispatch(formsActions.getFormByCollectionId({
        collectionId: this.data.CollectionsID,
        formGridParentFilter: this.parentFilter,
        addToViewStack: false
      }));
    } else if (this.formFieldId !== undefined) {
      this.store$.dispatch(formsActions.getFormByCollectionGridField({
        formFieldId: this.formFieldId!,
        addToViewStack: true
      }));
    }
  }

}
